import { Parser as HtmlToReactParser } from 'html-to-react'

const htmlToReactParser = HtmlToReactParser()

export const htmlParse = (text: string) => {
  return htmlToReactParser.parse(text)
}
